import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import ButtonA from '../components/typography/buttons/ButtonA'
import TextField from '../components/typography/TextField'
import PasswordField from '../components/typography/PasswordField'
import JustifyCenter from '../components/presentational/JustifyCenter'
import AuthWrapper from '../components/auth/AuthWrapper'
import InlineErrorMessage from '../components/auth/InlineErrorMessage'
import TextButton from '../components/typography/buttons/TextButton'
import { loginUser } from '../actions/user'
import QuestForwardQuestCommunity from '../static/images/logos/questmaker_tm_logo.svg'

const QuestForwardQuestCommunityIcon = styled.div`
  background: url(${QuestForwardQuestCommunity}) no-repeat;
  max-width: 270px;
  display: inline-block;
  background-size: 100%;
  margin: 8px auto 20px;
  height: 31px;
  width: 227px;
`

const LockedAccountMessage = styled.div`
  background-color: #f5f5f5;
  color: #666666;
  margin-right: -48px;
  margin-left: -50px;
  margin-bottom: 15px;
  padding: 10px 65px;
  line-height: 16px;
`

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: localStorage.getItem('lastLogin') || '',
      password: ''
    }

    this.handleEmailChangeBound = this.handleEmailChange.bind(this)
    this.handlePasswordChangeBound = this.handlePasswordChange.bind(this)
    this.loginBound = this.login.bind(this)
    this.shouldButtonBeDisabledBound = this.shouldButtonBeDisabled.bind(this)
    this.checkForSubmitBound = this.checkForSubmit.bind(this)
    this.onForgotPasswordClickBound = this.onForgotPasswordClick.bind(this)

    window.scrollTo(0, 0)
  }
  render() {
    return (
      <AuthWrapper>
        <QuestForwardQuestCommunityIcon />
        {this.props.statusText === 'Locked' && (
          <LockedAccountMessage>
            Your account {this.state.email} has been temporarily locked due to
            multiple failed login attempts. Check your email to unlock or tap
            forgot password below.
          </LockedAccountMessage>
        )}
        <form style={{ textAlign: 'left' }}>
          <TextField
            id="email-input"
            label="Email"
            type="email"
            margin="normal"
            defaultValue={this.state.email}
            onKeyPress={this.checkForSubmitBound}
            onChange={this.handleEmailChangeBound}
            autoFocus={!localStorage.getItem('lastLogin')}
            placeholder="Username or Email"
            style={{ marginBottom: '10px' }}
          />
          <PasswordField
            label="Password"
            value={this.state.password}
            onChange={this.handlePasswordChangeBound}
            autoFocus={localStorage.getItem('lastLogin') !== null}
            onKeyPress={this.checkForSubmitBound}
            placeholder="Password"
            style={{ marginBottom: '35px' }}
          />
          {this.props.statusText && (
            <InlineErrorMessage style={{ bottom: '25px' }}>
              Oops! Your username or password was incorrect.
            </InlineErrorMessage>
          )}
          <JustifyCenter>
            {this.props.isAuthenticating || this.props.isAuthenticated ? (
              <div
                className="loading submit"
                style={{ minHeight: '50px', width: '50px', margin: 'auto' }}
              />
            ) : (
              <ButtonA
                style={{ width: 'unset', marginBottom: '27px' }}
                type="submit"
                onClick={this.loginBound}
                disabled={this.shouldButtonBeDisabledBound()}
              >
                Sign In
              </ButtonA>
            )}
          </JustifyCenter>
        </form>
        <TextButton
          onClick={this.onForgotPasswordClickBound}
          style={{ marginTop: 'auto' }}
          fontSize="13px"
        >
          Forgot your password?
        </TextButton>
      </AuthWrapper>
    )
  }

  checkForSubmit(e) {
    if (e.which === 13 || e.keyCode === 13) {
      this.login(e)
    }
  }

  handleEmailChange(e) {
    this.setState({ email: e.target.value })
  }

  handlePasswordChange(e) {
    this.setState({ password: e.target.value })
  }

  login(e) {
    e.preventDefault()
    this.props.dispatch(loginUser(this.state.email, this.state.password))
  }

  shouldButtonBeDisabled() {
    return (
      this.props.isAuthenticating || !this.state.email || !this.state.password
    )
  }

  onForgotPasswordClick() {
    this.props.dispatch(push('/forgotpassword'))
  }
}

Login.propTypes = {
  isAuthenticating: PropTypes.bool.isRequired,
  statusText: PropTypes.string,
  isAuthenticated: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired
}

export const mapStateToProps = state => ({
  isAuthenticating: state.user.isAuthenticating,
  statusText: state.user.statusText || '',
  isAuthenticated: state.user.isAuthenticated
})

export default connect(mapStateToProps)(Login)
export { Login as LoginDisconnected } // pure component - used in tests



// WEBPACK FOOTER //
// ./src/containers/Login.js